
import { Vue, Component, Prop } from 'vue-property-decorator';

import GuideItem from '@/components/editorial/GuideItem.vue';
import UseArticleList from '@/helpers/composables/useArticleList';

const HiddenHorizontalScrollbar = () => import('@/components/HiddenHorizontalScrollbar.vue');

@Component({
	name: 'GuideList',
	components: {
		GuideItem,
		HiddenHorizontalScrollbar,
		UseArticleList,
	},
})
export default class GuideList extends Vue {
	@Prop({ default: 15 }) listSize: number;
	@Prop({ default: false }) inline: boolean;
	@Prop({ default: null }) entityId: null | string;
	@Prop({ default: false }) h4Heading: boolean;
}
